import axios from "axios";

// Inserisci direttamente l'URL di Render (senza /api in fondo, perché viene aggiunto sotto da baseURL)
const BACKEND_URL =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_BACKEND_URL) ||
  (typeof process !== "undefined" && process.env?.REACT_APP_BACKEND_URL) ||
  "https://alkeon-backend.onrender.com";

export const api = axios.create({
  baseURL: `${BACKEND_URL.replace(/\/$/, "")}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const FALLBACK_PRODUCTS = [
  {
    id: "aura",
    number: "01",
    name: "AURA",
    variant: "Sculptural Vase",
    category: "Vase",
    description:
      "An organic, hand-cast mineral composite vase defined by fluid spiral geometries and intricate fossil-like textures.",
    dimensions: "9 x 9 x 11 cm",
    price: 95,
    image: "images/AURA.jpg",
  },
  {
    id: "monolith",
    number: "02",
    name: "MONOLITH",
    variant: "Taper Candle Holder",
    category: "Candle Holder",
    description:
      "An striking vertical candle holder capturing raw geological presence, engineered to snugly fit standard taper candles.",
    dimensions: "10.5 x 10 x 8 cm",
    price: 80,
    image: "images/MONOLITH.jpg",
  },
  {
    id: "ammon",
    number: "03",
    name: "AMMON",
    variant: "Tealight Holder",
    category: "Candle Holder",
    description:
      "An elemental tealight holder shaped by the ancient spiral geometry of the ammonite, designed to cradle living flame within cold mineral stone.",
    dimensions: "8.5 x 8.5 x 4.5 cm",
    price: 55,
    image: "images/AMMON.jpg",
  },
  {
    id: "cratera",
    number: "04",
    name: "CRATERA",
    variant: "Valet Tray",
    category: "Accessories",
    description:
      "An tactile catchall bowl featuring dense central logarithmic patterns reminiscent of fossilized coral structures and primordial mineral growth.",
    dimensions: "19.5 x 21 x 5 cm",
    price: 140,
    image: "images/CRATERA.jpg",
  },
  {
    id: "fractal",
    number: "05",
    name: "FRACTAL",
    variant: "Set of 2 Coasters",
    category: "Tableware",
    description:
      "A pair of handcrafted coasters with hypnotizing vortex reliefs in the center.",
    dimensions: "12 x 12 x 2.5 cm each",
    price: 70,
    image: "images/FRACTAL.jpg",
  },
];

export const formatEUR = (n) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n ?? 0);